import React from 'react';

import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: '100vh',
    },
    container: {
        flexGrow: 1,
    },
}));

export default function MainLayout({ children }) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <main>
                <div className={classes.container}>{children}</div>
            </main>
        </div>
    );
}
